import { BlocksTitle } from '@components/Blocks/shared/BlocksTitle';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Scalars } from '@graphql/generated-contentful/graphql';
import { Maybe } from '@lib/types/Maybe';
import { ArrowRight } from 'phosphor-icons';

export const ProductRowHeading = ({
  title,
  description,
  text,
  link,
  onLinkClick,
}: {
  title: Maybe<string>;
  description?: Scalars['JSON']['output'];
  text?: Scalars['JSON']['output'];
  link?: { href: string; label: string };
  onLinkClick?: (label: string) => void;
}) => {
  const linkAriaLabelFallbackText = text?.json
    ? documentToPlainTextString(text.json)
    : '';

  let linkAriaLabel = link?.label ?? '';

  if (title) {
    linkAriaLabel += ` ${title}`;
  } else if (linkAriaLabelFallbackText) {
    linkAriaLabel += ` ${linkAriaLabelFallbackText}`;
  }

  return (
    <div className="container mb-4 flex justify-end">
      {(title || description || text) && (
        <div className="-mb-4 mr-auto">
          {/* negative bottom margin to account for margin being added to bottom of elements in RichText element. This keeps the Link aligned with bottom of the text content */}
          <BlocksTitle title={title} description={description} text={text} />
        </div>
      )}
      {link && (
        <a
          data-test="product-row-heading-link"
          href={link.href}
          className="ml-4 flex flex-shrink-0 items-center self-end text-blue"
          onClick={() => onLinkClick && onLinkClick(link.label)}
          aria-label={linkAriaLabel}
        >
          {link.label}
          <ArrowRight className="ml-1 inline-block" />
        </a>
      )}
    </div>
  );
};
